import { render, staticRenderFns } from "./Courtesies.vue?vue&type=template&id=50c3280c&scoped=true&"
import script from "./Courtesies.vue?vue&type=script&lang=js&"
export * from "./Courtesies.vue?vue&type=script&lang=js&"
import style0 from "./Courtesies.vue?vue&type=style&index=0&id=50c3280c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c3280c",
  null
  
)

export default component.exports